export type HubEnvelope<T = unknown> = {
    type: string;
    payload: T;
    timestampUtc: string;
};

export type SignalRProtocol = 'json' | 'messagepack';

export type HubConnectionState = 'disconnected' | 'connecting' | 'connected' | 'reconnecting';

export const HubClientMethods = {
    Receive: 'Receive',
} as const;

export const RetroEventTypes = {
    UserJoined: 'retro.userJoined',
    UserLeft: 'retro.userLeft',
    CursorMoved: 'retro.cursorMoved',
    PresenceSnapshot: 'retro.presenceSnapshot',
    CardsSnapshot: 'retro.cardsSnapshot',
    CardAdded: 'retro.cardAdded',
    CardUpdated: 'retro.cardUpdated',
    CardMoved: 'retro.cardMoved',
    CardDeleted: 'retro.cardDeleted',
    Confetti: 'retro.confetti',
    RoomState: 'retro.roomState',
} as const;

export const StudioBatchEventTypes = {
    ItemUpdated: 'studioBatch.itemUpdated',
    MetricsUpdated: 'studioBatch.metricsUpdated',
} as const;

export type StudioBatchItemUpdatedPayload = {
    barcode: string;
    aggregateStatus: string | null;
    createdBy: string | null;
    assignee: string | null;
    updatedAtUtc: string;
};

export type UserPresencePayload = {
    connectionId: string;
    userRef: string;
    displayName: string;
    roomId: string;
    activeCount: number;
};

export type CursorPositionPayload = {
    connectionId: string;
    userRef: string;
    displayName: string;
    roomId: string;
    x: number;
    y: number;
};

export type PresenceSnapshotPayload = {
    roomId: string;
    activeCount: number;
    members: UserPresencePayload[];
};

export type RetroCardPayload = {
    id: string;
    roomId: string;
    text: string;
    x: number;
    y: number;
    color: string;
    createdByUserRef: string;
    createdByConnectionId: string;
    createdByDisplayName: string;
    updatedByUserRef: string;
    updatedByDisplayName: string;
    updatedAtUtc: string;
};

export type RetroCardsSnapshotPayload = {
    roomId: string;
    cards: RetroCardPayload[];
};

export type RetroConfettiPayload = {
    roomId: string;
    connectionId: string;
    userRef: string;
    displayName: string;
};

export type RetroRoomStatePayload = {
    roomId: string;
    adminConnectionId: string;
    adminUserRef: string;
    adminDisplayName: string;
    contentHidden: boolean;
};
